import { useState } from 'react'
import PropTypes from 'prop-types'

const InlineCode = ({ text, copyable = false }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy text:', err)
    }
  }

  return (
    <code className="inline-flex items-center px-1.5 py-0.5 text-sm bg-gray-900/50 border border-gray-700/50 rounded font-mono">
      {text}
      {copyable && (
        <button
          onClick={handleCopy}
          className="ml-2 text-gray-400 hover:text-white transition-colors"
          title={copied ? 'Copied!' : 'Copy'}
        >
          {copied ? (
            <span className="text-green-400 text-xs">✓</span>
          ) : (
            <span className="text-xs">📋</span>
          )}
        </button>
      )}
    </code>
  )
}

InlineCode.propTypes = {
  text: PropTypes.string.isRequired,
  copyable: PropTypes.bool,
}

export default InlineCode
